// selectors.
import { selectUser } from '../../../../../redux/reducers/userSelectors';
import { useAppSelector } from '../../../../../redux/hooks';

// interfaces.
import { ActionTaskEnum } from '../components/ApproverTaskAction';
import { ApproverTaskItem } from '../../../../../domains/approver-review/interfaces/interfaces';

// assets.
import swapIcon from '../../../../../assets/icons/swap-icon.svg';
import disabledSwapIcon from '../../../../../assets/icons/swap-disabled.svg';

export const getSwapButtonInfo = (approverTask: ApproverTaskItem) => {
  const email = useAppSelector(selectUser)?.email;

  const { agent, status } = approverTask;

  const isDifferentAgent = agent && agent !== email;

  const isDisabled = Boolean(
    isDifferentAgent && status === ActionTaskEnum.PROGRESS
  );

  return {
    icon: isDisabled ? disabledSwapIcon : swapIcon,
    label: 'Cambiar',
    isDisabled,
    isDifferentAgent,
  };
};
